import React, { useEffect, useState } from "react"
import Footer from "./footer"
import Header from "../components/header"
import axios from "axios"
import JoinContext from "../context/join-context"
import TOP from "./top"
const Layout = props => {
  const { children, uri } = props
  const [join, setJoin] = useState({ state: "OTHER" })
  useEffect(() => {
    //prod `https://netvideogirls.com/tour-actions/jo.php`
    //dev `http://192.168.86.43:4000/jo.php`
    const fetchJoinData = axios(
      `https://netvideogirls.com/tour-actions/jo.php`,
      {
        headers: {
          "x-xsrf-header":
            "i4GOKD13ZT$TN#3qzVMdzAX3!JV3R5GPv$aFxM8Mz6nO5uKUaGS6Y7X$Cqao8",
        },
      }
    )

    //dev http://192.168.86.43:4000/s.php
    //prod `https://netvideogirls.com/tour-actions/s.php?cache=${Date.now()}`
    const fetchStateData = fetch(
      `https://netvideogirls.com/tour-actions/s.php?cache=${Date.now()}`
    ).then(res => res.json())

    Promise.all([fetchJoinData, fetchStateData])
      .then(([joinRes, stateRes]) => {
        const contextValue = {
          ...joinRes.data,
          state: stateRes.state !== "OTHER" ? stateRes.state : null,
          state_info: stateRes.state_info || null,
          country_info: stateRes.country_info || null,
        }
        setJoin(contextValue)
      })
      .catch(err => {
        console.error("Error fetching data:", err)
        // Handle error appropriately
      })
  }, [])

  return (
    <div>
      <Header active={uri} />
      <JoinContext.Provider value={join}>{children}</JoinContext.Provider>
      <Footer state={join.state} />
      <TOP />
    </div>
  )
}
export default Layout
